import { render } from "./calendar-selector.vue?vue&type=template&id=5504845e"
import script from "./calendar-selector.vue?vue&type=script&lang=js"
export * from "./calendar-selector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__